import { apiService } from "@/common/api.service.js";

export default {
  // EEOS rates by site
  eeosRates(payload) {
    const endpoint = `/metrics/eeos-rate/?site_code__site_code=${payload.site}`;
    return apiService(endpoint);
  },
};
